import { useState } from 'react';
import { UseSortingParams, UseSortingValue } from './useSorting.types';

const deafultSortingParams: UseSortingParams = {
  multiple: false,
};

const useSorting = ({ multiple } = deafultSortingParams): UseSortingValue => {
  const [sorting, setSorting] = useState<Map<string, boolean>>(new Map<string, boolean>());

  const handleSorting = (column: string): void => {
    const columnSorting = sorting;

    // if column is not sorted, then add to sort
    if (!isColumnSorted(column)) {
      if (!multiple) {
        columnSorting.clear();
      }

      columnSorting.set(column, true);
    } else if (isAscendingSorted(column)) {
      columnSorting.set(column, false);
      // if column is sorted and is asc, then make desc
    } else {
      columnSorting.delete(column);
      // otherwise remove it
    }
    setSorting(new Map(columnSorting));
  };

  const isColumnSorted = (column: string): boolean => {
    return sorting?.get(column) !== undefined;
  };

  const isAscendingSorted = (column: string): boolean => {
    return isColumnSorted(column) && sorting?.get(column) === true;
  };

  return {
    sorting,
    handleSorting,
    isColumnSorted,
    isAscendingSorted,
  };
};

export default useSorting;
